var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18606_13510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.88932 8.61109C3.88932 6.61673 5.50607 4.99998 7.50043 4.99998H11.6671C12.1273 4.99998 12.5004 4.62688 12.5004 4.16665C12.5004 3.70641 12.1273 3.33331 11.6671 3.33331H7.50043C4.5856 3.33331 2.22266 5.69625 2.22266 8.61109V9.44442C2.22266 11.7774 3.73567 13.7555 5.83377 14.4534V16.6666C5.83377 16.9814 6.01107 17.2692 6.29212 17.4108C6.57317 17.5525 6.91003 17.5237 7.16297 17.3364L10.6938 14.7222H12.5004C15.4153 14.7222 17.7782 12.3593 17.7782 9.44442C17.7782 8.98419 17.4051 8.61109 16.9449 8.61109C16.4846 8.61109 16.1115 8.98419 16.1115 9.44442C16.1115 11.4388 14.4948 13.0555 12.5004 13.0555H10.4189C10.2404 13.0555 10.0665 13.1129 9.92304 13.2191L7.50043 15.0128V13.8109C7.50043 13.4105 7.21574 13.0667 6.82241 12.9921C5.15215 12.6753 3.88932 11.2064 3.88932 9.44442V8.61109Z",
    fill: "#002CFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1671 3.33331C13.7069 3.33331 13.3338 3.70641 13.3338 4.16665C13.3338 4.62688 13.7069 4.99998 14.1671 4.99998L14.933 4.99998L11.3556 8.57739C11.0302 8.90283 11.0302 9.43046 11.3556 9.7559C11.6811 10.0813 12.2087 10.0813 12.5341 9.7559L16.1115 6.17849L16.1115 6.94442C16.1115 7.40466 16.4846 7.77776 16.9449 7.77776C17.4051 7.77776 17.7782 7.40466 17.7782 6.94442L17.7782 4.16665C17.7782 3.70641 17.4051 3.33331 16.9449 3.33331H14.1671Z",
    fill: "#002CFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18606_13510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/iconChat.99db42ace0ae7c721eb3ffedfb1c95c9.svg";
export { ForwardRef as ReactComponent };